module.exports = __webpack_public_path__ + "media/flat/diners-d81b8b4c.svg";